
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, Dropdown, List, Label, Popup, Checkbox, Segment, ButtonGroup, ButtonOr, Menu, MenuItem } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../App.js';
import axios from 'axios';
// import {retrieveSubjectObject, nounoptions1, nounoptions2, nounoptions3, nounoptionsmodalis, options1, options2, options3, verbPostbases, nounPostbases} from './constants/constants.js'
import {phrasebook} from './constants/phrasebook.js';
import raw2026Videos from './transcriptions2026/raw2026Videos';

import {groups, grouplist} from './transcriptions2026/allgroupedsrts.js';
import {subtitles} from './transcriptions2026/all2026srts.js';

// import {postbasesEndingsUnderlying} from './constants/underlying.js'
// import palette from 'google-palette';
// import shuffle from 'shuffle-array';
// import { TagColors } from './HomeHelper.js';
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
// import L from "leaflet";
// import {geoJSONMap} from "./constants/placenames20.js";
// import 'leaflet/dist/leaflet.css';
// import 'leaflet.zoomhome/dist/leaflet.zoomhome.js';
// // import icon from 'leaflet/dist/images/marker-icon.png';
// // import iconShadow from 'leaflet/dist/images/marker-shadow.png';
// import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
// import "leaflet-extra-markers/dist/js/leaflet.extra-markers.js";
// // import { library } from '@fortawesome/fontawesome-svg-core'
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// // import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// // import { dom } from '@fortawesome/fontawesome-svg-core'
// // dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
// import { library, dom } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// library.add(fas) 
// dom.i2svg() 

ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let underlineColor = '#b5b5b5'

const options = [
  { key: 's', text: 'Tlingit only', value: 0 },
  { key: 'se', text: 'Tlingit with English', value: 1 },
  { key: 'b', text: 'Book', value: 2 },
]

class NewVideoList extends Component {
	constructor(props) {
    super(props);

    let currentChapter = decodeURI(props.match.params.num)
    console.log(groups, currentChapter)
    if (currentChapter == null || !(currentChapter in groups)) {
      currentChapter = 'Featured'
      this.props.history.push('/newvideolist/Featured')            
    }

		this.state = {
      parseIndex:0,
      presentation:5,
      chapter:currentChapter,
      // activeChapter:'1',
      sortValue:0,
			// map:undefined,
			// markersById:{},
			// overlayMaps:{},
   //    sortValue:0,
			history: props.location.state === undefined ? [] : props.location.state.history,
			// from: props.location.state === undefined ? '' : props.location.state.from,
		}	   
		scroll.scrollTo(0);
    // let weburl = https://www.haashuka.com

	}

	repeatAudio(audio, event, data) {
	  if (!this.state.playingAudio) {

	    let sound = new Audio(API_URL + "/tlingitaudiolibrary/" +  audio);
	    this.setState({playingAudio: true});

	    sound.play()

	    sound.onended=()=>{
	      this.setState({playingAudio: false});
	    }
	  }
	}

// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
// <link href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&amp;display=swap" rel="stylesheet">
// [leaflet-map address="Juneau, Alaska" zoom="10" height="700" tileurl=https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.jpg zoomcontrol dragging scrollwheel gesture doubleclickzoom]
// [leaflet-geojson src="https://gist.githubusercontent.com/lonnystrunk/fd99e52cfb86c1ebe207506bad898119/raw/fffe18df77df9c39af18a272d708b905571d7c92/placenames.geojson"]
	// <span style="font-family:'Raleway'"><b>{name}</b> #{id}
	// {translation}
	// {location}</span>
// [/leaflet-geojson]
// [geojsonmarker svg property=marker-color 
	// icondefault=#B5B5B5 
	// iconprops="#0056d6,#6EE5FF,#2EA524,#890101,#6F4413,#7c7c7c" 
	// shape=circle 
	// icon=fa-solid 
	// prefix=fa-circle 
	// disableClusteringAtZoom=4  
	// values="#0056d6,#00c7fc,#4f7a28,#555555,#d95000,#b5b5b5" 
	// groups="Water,Ice,Land,Settlement,Trail,Unsure" 
	// visible=1,1,1,1,1,0]
// [fullscreen][zoomhomemap !fit]

	componentDidMount() {
    // this.initialize()

	}

  // initialize = () => {
  //   let weburl = 'localhost:3000'
  //   window.location.href = weburl+"/phrasebook?chapter="+encodeURIComponent(this.state.chapter);
  //   // const params = new URLSearchParams(search);
  //   // const foo = params.get('bar');
  //   const queryParameters = new URLSearchParams(window.location.search)
  //   const type = queryParameters.get("chapter")
  //   // const [searchParams] = useParams()
  //   // const newchapter = searchParams.get("chapter")
  //   // console.log(newchapter) 
  // }

  processStyledText = (sentence) => {
      sentence = sentence.replaceAll("???","...")
      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«",'"').replaceAll("»",'"')

      return <span>{sentence}</span>


    // sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«","").replaceAll("»","")
    // let matches = sentence.match(/⎡.*?⎤/g)
    // let matches1 = sentence.match(/{.*?}/g)
    // let matches2 = sentence.match(/_.*?_/g)
    // // console.log(matches2)
    // if (matches !== null || matches1 !== null || matches2 !== null) {
    //   if (matches !== null) {
    //     matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
    //   }
    //   if (matches1 !== null) {
    //     matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
    //   }
    //   if (matches2 !== null) {
    //     matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //   }
    //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
    // } else {
    //   return <span>{sentence}</span>
    // }


  }

  handleChapterClick = (e, {value}, chapter) => {
    // console.log(e, value, chapter)
    if (chapter == undefined) {
      chapter = value
    } else if (typeof chapter === "object") {
      chapter = e
    }
    this.props.history.push('/newvideolist/'+chapter)
    this.setState({chapter:chapter})
    // scroll.scrollTo(0);
  }

  handleSortChange = (e, {value}) => {
    if (value === 0 && this.state.sortValue !== 0) {
      this.setState({sortValue: 0})
    } else if (value === 1 && this.state.sortValue !== 1) {
      this.setState({sortValue: 1})
    } else if (value === 2 && this.state.sortValue !== 2) {
      this.setState({sortValue: 2})
    }
  } 


	render() {
    console.log(this.state)

    // let activeChapter = this.state.chapter
    let fontSize = '20px'
    let innerWidthSetting = 600
    if (window.innerWidth < innerWidthSetting) {
      fontSize = '16px'
    }
    let showLargerTable = window.innerWidth >= 480

    // console.log(window.innerWidth)
    let chapterOptions = []
    grouplist.map((k)=>{chapterOptions.push({ key: k[0], text: k[1], value: k[1]})})
    // console.log(chapterOptions)

		return (
			<div className="home" style={{fontFamily:customFontFam}}>


{/*          <Link to={{pathname: "/"}} >
            <Button basic style={{fontSize:'14px',paddingLeft:'10px',paddingRight:'15px',margin:'6px 0px'}} icon='left chevron' content='Back to Homepage' />
          </Link>  */}


        <div className='yugtatun'>Nutarat Suuliaret</div>
        <div className='yugtatunsub'>New Yugtun Videos</div>

        <div style={{display:'flex',justifyContent:'center',flexDirection:'row',flexWrap:'wrap',maxWidth:'920px',marginLeft:'auto',marginRight:'auto'}}>      

          <div style={{display:'flex',flexDirection:'column',margin:fontSize,marginTop:'8px'}}>
          {/*<div style={{fontSize:'19px',lineHeight:'25px',color:'#000000DE',fontWeight:'600',padding:10}}>KYUK 2026 Yugtun Video Collection</div>*/}
          <div style={{fontSize:'16px',color:'#000000DE',padding:'10px',fontWeight:'400',lineHeight:'23px',textAlign:'center'}}>
          <span>This is a collection of newly archived videos in Yugtun curated by KYUK and Yuarcuun Technologies in 2026. Each recording contains Yugtun transcriptions with clickable subtitles to access word translations.</span>
          </div>
          </div>


          <Grid>
            <Grid.Row>
            {window.innerWidth < innerWidthSetting ?
              null
              :
              <Grid.Column width={4}>
                <Menu fluid vertical tabular>
                  {grouplist.map((k)=>
                    <MenuItem
                      active={this.state.chapter === k[0]}
                      value={k[0]}
                      onClick={this.handleChapterClick}
                    >{k[1]}</MenuItem>
                  )}
                </Menu>
              </Grid.Column>
            }

            <Grid.Column stretched width={(window.innerWidth < innerWidthSetting ? 16:12)}>
              <Segment>

            <Grid textAlign='center'>
            <Grid.Row style={{padding:0,margin:0,}}>
              <Grid.Column style={{ padding: 0, margin: 0 }} textAlign='left'>
                <div>

                  <div>

                      <div>

                        <div style={{display:'flex',backgroundColor:'#F3F3F3',flexDirection:(window.innerWidth < innerWidthSetting ? 'column':'row'),justifyContent:'space-between',alignItems:'center'}}>
                          
                          <div className='hierarchymain' style={{flex:2,height:'100%',padding:(window.innerWidth < innerWidthSetting ? '5px': '15px 0px'),marginLeft:8}}>
                              {window.innerWidth < innerWidthSetting ? 
                                <Dropdown fluid selection selectOnBlur={false} options={chapterOptions} text={this.state.chapter.replaceAll('-',' ')} style={{minWidth:'200px', backgroundColor:'white', fontFamily:customFontFam,fontSize:'15px',fontWeight:400,color:'#000000DE'}}>
                                  <Dropdown.Menu style={{maxHeight:'190px'}}>
                                    {grouplist.map((k,kindex)=>{
                                      return <Dropdown.Item onClick={this.handleChapterClick.bind(this,k[0])} active={this.state.chapter == k[0]}>{k[1]}</Dropdown.Item>
                                    })}
                                  </Dropdown.Menu>
                                </Dropdown>
                                :
                                <span style={{marginLeft:8}}>{this.state.chapter.replaceAll('-',' ')}</span>
                              }
                          </div>
                           

                        </div>

                        <div style={{display:'flex',flexWrap:'wrap',fontSize:'16px',justifyContent:'center'}}>
                          {groups[this.state.chapter].map((y,yindex)=>
                            (showLargerTable ? 
                              <Grid style={{maxWidth: 660, marginTop:'15px'}}>
                                <Grid.Row columns={2} style={{alignItems:'center',margin:'0px 10px'}}>
                                  <Grid.Column width={6}>
                                  <Link to={{pathname: '/2026list/'+y,  state: { history:'/newvideolist/'+this.state.chapter}}}>
                                    <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/hqdefault.jpg'}  />
                                    {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                                  </Link>
                                  </Grid.Column>
                                  <Grid.Column width={10}>
                                    <Link style={{color:'#000000DE'}} to={{pathname: '/2026list/'+y}}>
                                      <div style={{fontWeight:'600'}}>{raw2026Videos[y]['thumbnail-title']}</div>
                                    </Link>
                                    <div style={{color:'#00000099',fontSize:'14px',marginTop:'6px',marginBottom:'5px'}}>{raw2026Videos[y].date}</div>
                                    <div style={{fontSize:'14px',lineHeight:'17px'}}>{raw2026Videos[y]['general-description']}</div>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                              :
                              <Grid style={{marginTop:'15px'}}>
                                <Grid.Row columns={2} style={{alignItems:'center',margin:'0px 10px'}}>
                                  <Grid.Column width={7}>
                                  <Link to={{pathname: '/2026list/'+y,  state: { history:'/newvideolist/'+this.state.chapter}}}>
                                    <Image style={{margin:"0px 10px",borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/hqdefault.jpg'} />
                                    {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
                                  </Link>
                                  </Grid.Column>
                                  <Grid.Column width={9}>
                                    <Link style={{color:'#000000DE'}} to={{pathname: '/2026list/'+y}}>
                                      <div style={{fontWeight:'600'}}>{raw2026Videos[y]['thumbnail-title']}</div>
                                    </Link>
                                  <div style={{color:'#00000099',fontSize:'14px',marginTop:'6px',marginBottom:'5px'}}>{raw2026Videos[y].date}</div>
                                  <div style={{fontSize:'14px',lineHeight:'17px'}}>{raw2026Videos[y]['general-description']}</div>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            )
                          )}
                          </div>


                    </div>
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
            </Grid>


              </Segment>
            </Grid.Column>
            </Grid.Row>
          </Grid>

        </div>
    
			</div>

		);
	}
}
export default NewVideoList;
